import React, { useContext } from "react";
import { Navigate, useParams } from "react-router-dom";

import PageLayout from "@/components/layouts/page/PageLayout";
import ExtendCampaignBase from "../components/ExtendCampaign";
import { GlobalContext } from "@/helpers/contexts/contexts";
import { BRAND_CONST, USER_ROLE } from "@/config/constants";
import { ROUTES } from "@/helpers/routes/routePaths";

const ExtendCampaign = ExtendCampaignBase as React.ComponentType<{
  campaignId?: string;
}>;

function ExtendCampaignPage() {
  const { campaignId } = useParams();
  const { selectedBrand, loggedInUserRole } = useContext(GlobalContext);

  if (
    loggedInUserRole !== USER_ROLE.PARTICIPANT.NAME &&
    (selectedBrand?.id === BRAND_CONST.MS_BRAND_ID ||
      selectedBrand?.id === BRAND_CONST.KUMON_BRAND_ID)
  ) {
    // this feature not available for non-participant users
    // this feature not available for MS and Kumon brands
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return (
    <PageLayout className="mx-0 mx-sm-2">
      <ExtendCampaign campaignId={campaignId} />
    </PageLayout>
  );
}

export default ExtendCampaignPage;
